module.exports = __webpack_public_path__ + "img/lime.84372fc4.svg";